import { BaseContextSetup, NoAdsDetector } from '@platforms/shared';
import { context, InstantConfigService } from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
import { UcpDesktopStickyTopBoxAdExperiment } from './../../experiments/ucp-desktop-sticky-topboxad-experiment';

@Injectable()
export class UcpDesktopBaseContextSetup extends BaseContextSetup {
	constructor(
		private ucpDesktopStickyTopBoxAdExperiment: UcpDesktopStickyTopBoxAdExperiment,
		protected instantConfig: InstantConfigService,
		protected noAdsDetector: NoAdsDetector,
	) {
		super(instantConfig, noAdsDetector);
	}

	execute(): void {
		super.execute();

		context.set(
			'options.floatingMedrecDestroyable',
			this.instantConfig.get('icFloatingMedrecDestroyable'),
		);
		// sourced from front/scripts/shared/tracking/Tracker.js getUserIdForInternalTracking()
		context.set(
			'options.userId',
			(window.mw as any).config.get('wgTrackID') || (window.mw as any).config.get('wgUserId'),
		);
		context.set('options.disableStickyTopBoxAd', this.instantConfig.get('icDisableStickyTopBoxAd'));

		if (!context.get('options.disableStickyTopBoxAd')) {
			this.setupStickyTopBoxAdExperiment();
		}
	}

	private setupStickyTopBoxAdExperiment(): void {
		if (this.ucpDesktopStickyTopBoxAdExperiment.isTopBoxAdSticky()) {
			document.body.classList.add('has-sticky-top-box-ad');
		}
	}
}
